import React from 'react';

const Testimonials = () => {
  const clientLogos = [
    '/HIKO.png',
    '/colorflex.png',
    '/dotpropack.jpg',
    '/Rahil.jpg',
    '/dupont.png',
    '/ITClogo.png',
    '/safeco.jpg',
    '/LG.png',
    '/tetra.png',
    '/snk.png',
    '/swanson.jpg',
    '/Tecline.png',
    '/USI.jpg',
    '/rhyno.jpg',
    '/golden.jpg',
    '/ISOLA.jpg',
    '/HIKO.png',
    '/colorflex.png',
    '/dotpropack.jpg',
    '/Rahil.jpg',
    '/dupont.png',
    '/ITClogo.png',
    '/safeco.jpg',
    '/LG.png',
    '/tetra.png',
    '/snk.png',
    '/swanson.jpg',
    '/Tecline.png',
    '/USI.jpg',
    '/rhyno.jpg',
    '/golden.jpg',
    '/ISOLA.jpg',
    '/HIKO.png',
    '/colorflex.png',
    '/dotpropack.jpg',
    '/Rahil.jpg',
    '/dupont.png',
    '/ITClogo.png',
    '/safeco.jpg',
    '/LG.png',
    '/tetra.png',
    '/snk.png',
    '/swanson.jpg',
    '/Tecline.png',
    '/USI.jpg',
    '/rhyno.jpg',
    '/golden.jpg',
    '/ISOLA.jpg'

  ];

  return (
    <section className="bg-black py-16 px-8">
      <h2 className="text-4xl font-bold text-center text-white mb-8">
        Our Clients
      </h2>
      <div className="overflow-hidden relative">
        {/* Moving container with duplicate logos */}
        <div className="marquee">
          <div className="track">
            {clientLogos.map((logo, index) => (
              <img
                key={index}
                src={logo}
                alt={`Client ${index + 1}`}
                className="h-24 w-auto object-contain mx-4"
              />
            ))}
            {/* Duplicate logos for seamless transition */}
            {clientLogos.map((logo, index) => (
              <img
                key={`duplicate-${index}`}
                src={logo}
                alt={`Client Duplicate ${index + 1}`}
                className="h-24 w-auto object-contain mx-4"
              />
            ))}
        
          </div>
        </div>
      </div>
      <style jsx>{`
        .marquee {
          display: flex;
          overflow: hidden;
          position: relative;
          width: 100%;
          height: 6rem;
        }

        .track {
          display: flex;
          animation: scroll 40s linear infinite;
          width: calc(200%);
        }

        @keyframes scroll {
          from {
            transform: translateX(0);
          }
          to {
            transform: translateX(-400%);
          }
        }
      `}</style>
    </section>
  );
};

export default Testimonials;
